import { Component, ChangeDetectionStrategy } from "@angular/core";
import { UpperCasePipe } from "@angular/common";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslatePipe } from "@ngx-translate/core";
import { ActionButtonComponent } from "../../features/login/landing/action-button.component";

@Component({
  selector: "app-leave-form",
  standalone: true,
  templateUrl: "./leave-form.component.html",
  styleUrls: ["./leave-form.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    UpperCasePipe,
    ActionButtonComponent,
  ],
})
export class LeaveFormComponent {
  constructor(
    private dialogRef: MatDialogRef<LeaveFormComponent>,
  ) {}

  onClose(value: boolean): void {
    this.dialogRef.close(value);
  }
}
